import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Auth, RequireAuth, useAuth } from './auth';
import { CalibrationCapture } from './pages/CalibrationCapture';
import { LensCapture } from './pages/LensCapture';
import { Capture } from './pages/Capture';
import { Job } from './pages/Job';
import { Jobs } from './pages/Jobs';
import { Printers } from './pages/Printers';
import { Review } from './pages/Review';

/**
 * Two apps sharing one bundle.
 *
 * `/capture/:jobId` is the phone: no Cognito, no navigation, authenticated by
 * the job-scoped token in the QR link. `/capture/printers/:printerId` is the
 * same for a printer's calibration photograph (F11), on a printer-scoped one. Everything else is the workstation and
 * is behind sign-in. They are kept in one deployment because they are one
 * product and the phone page changes whenever the refusal copy does.
 */
export function App() {
  const location = useLocation();
  if (location.pathname.startsWith('/capture/')) {
    return (
      <Routes>
        <Route path="/capture/:jobId" element={<Capture />} />
        <Route path="/capture/printers/:printerId"
               element={<CalibrationCapture />} />
        <Route path="/capture/printers/:printerId/lens"
               element={<LensCapture />} />
      </Routes>
    );
  }
  return (
    <Auth>
      <RequireAuth>
        <Workstation />
      </RequireAuth>
    </Auth>
  );
}

function Workstation() {
  const auth = useAuth();
  return (
    <>
      <nav className="nav">
        <Link className="brand" to="/">Stitch Lane</Link>
        <Link to="/">Jobs</Link>
        <Link to="/printers">Printers</Link>
        <span className="spacer" />
        <span className="muted">{auth.user?.profile.email}</span>
        <button className="link" onClick={() => void auth.removeUser()}>
          Sign out
        </button>
      </nav>
      <main>
        <Routes>
          <Route path="/" element={<Jobs />} />
          <Route path="/jobs/:jobId" element={<Job />} />
          <Route path="/jobs/:jobId/sheets/:sheetId" element={<Review />} />
          <Route path="/printers" element={<Printers />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}
